import type { UserAccount } from "@/lib/api";
import {
  UserStatusFilter,
  countUsersByStatus,
  filterUsersByStatus,
} from "@/features/admin/features/users/filter-users-by-status";
import { searchUsersByEmail } from "@/features/admin/features/users/search-users-by-email";

export interface StatusSearchCount {
  matched: number;
  total: number;
}

export interface StatusSearchCounts {
  active: StatusSearchCount;
  inactive: StatusSearchCount;
  unknown: StatusSearchCount;
}

const countMatchedInStatusGroup = (
  users: UserAccount[],
  statusFilter: Exclude<UserStatusFilter, "all">,
  query: string,
): number => searchUsersByEmail(filterUsersByStatus(users, statusFilter), query).length;

export const countStatusSearchMatches = (
  users: UserAccount[],
  query: string,
): StatusSearchCounts => {
  const totals = countUsersByStatus(users);

  return {
    active: {
      matched: countMatchedInStatusGroup(users, "active", query),
      total: totals.active,
    },
    inactive: {
      matched: countMatchedInStatusGroup(users, "invited", query),
      total: totals.inactive,
    },
    unknown: {
      matched: countMatchedInStatusGroup(users, "unknown", query),
      total: totals.unknown,
    },
  };
};
